var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2507",
  transform: "translate(-552 -456)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1721",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(552 456)",
  fill: "#b726fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 32",
  d: "M561.812 462.265c-1.001-.621-1.812-.113-1.812 1.135v9.2c0 1.248.811 1.756 1.812 1.136l7.438-4.612a1.216 1.216 0 000-2.247z",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/mediaican.997ddaa5.svg";
export { SvgComponent as ReactComponent };